import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { triggerSubtleConfetti } from '../utils/confetti';
import ConnectModal from './ConnectModal';
import LanguageSelector from '../src/components/LanguageSelector';
import { useTranslation } from 'react-i18next';
const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [isConnectModalOpen, setIsConnectModalOpen] = useState(false);
  const {
    t
  } = useTranslation();
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const handleConnectClick = e => {
    triggerSubtleConfetti(e.currentTarget);
    setIsConnectModalOpen(true);
  };
  return <>
      <nav className={`fixed top-0 left-0 right-0 h-[72px] backdrop-blur-nav z-50 transition-all duration-300 
        ${scrolled ? 'bg-cream-white/80 shadow-sm' : 'bg-cream-white/50'}`} data-id="element-665">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full flex items-center justify-between" data-id="element-666">
          {/* Logo Section - now serves as home link */}
          <a href="#" className="flex items-center hover:opacity-80 transition-opacity duration-300" onClick={e => triggerSubtleConfetti(e.currentTarget)} data-id="element-667">
            <div className="flex flex-col" data-id="element-668">
              <h1 className="text-2xl font-semibold text-charcoal" data-id="element-669">MONA</h1>
              <p className="text-xs text-grey-600" data-id="element-670">RN, BSc (Nursing)</p>
            </div>
          </a>
          {/* Navigation Items - Desktop - removed redundant items */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-671">
            {[{
            key: 'about',
            href: '#about'
          }, {
            key: 'expertise',
            href: '#expertise'
          }, {
            key: 'certifications',
            href: '#certifications'
          }].map(item => <a key={item.key} href={item.href} className="text-sm text-grey-600 hover:text-sage-mint relative group transition-all duration-300" onClick={e => triggerSubtleConfetti(e.currentTarget)} data-id="element-672">
                {t(`nav.${item.key}`)}
                <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-sage-mint group-hover:w-full transition-all duration-300" data-id="element-673"></span>
              </a>)}
          </div>
          {/* Language Selector and CTA Button */}
          <div className="hidden md:flex items-center space-x-6" data-id="element-674">
            <LanguageSelector data-id="element-675" />
            <button id="connect-button" className="liquid-glass-button relative overflow-hidden bg-sage-mint/90 text-white rounded-full px-6 py-2 transition-all duration-300 transform hover:scale-105 hover:shadow-glow-mint active:scale-98" onClick={handleConnectClick} data-id="element-676">
              <span className="relative z-10" data-id="element-677">{t('nav.connect')}</span>
              <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none" style={{
              background: `radial-gradient(circle at 50% 50%, rgba(255, 255, 255, 0.7) 0%, rgba(255, 255, 255, 0) 60%)`
            }} data-id="element-678" />
            </button>
          </div>
          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center space-x-4" data-id="element-679">
            <LanguageSelector data-id="element-680" />
            <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="text-charcoal transition-all duration-300 hover:text-sage-mint hover:scale-110" data-id="element-681">
              {isMenuOpen ? <X size={24} data-id="element-682" /> : <Menu size={24} data-id="element-683" />}
            </button>
          </div>
        </div>
        {/* Mobile Navigation Menu */}
        {isMenuOpen && <div className="md:hidden bg-white/90 backdrop-blur-lg absolute top-[72px] left-0 right-0 p-4 shadow-card" data-id="element-684">
            <div className="flex flex-col space-y-4" data-id="element-685">
              {[{
            key: 'about',
            href: '#about'
          }, {
            key: 'expertise',
            href: '#expertise'
          }, {
            key: 'certifications',
            href: '#certifications'
          }].map(item => <a key={item.key} href={item.href} className="text-sm text-grey-600 hover:text-sage-mint py-2 transition-all duration-300" onClick={e => {
            setIsMenuOpen(false);
            triggerSubtleConfetti(e.currentTarget);
          }} data-id="element-686">
                  {t(`nav.${item.key}`)}
                </a>)}
              <button className="liquid-glass-button bg-sage-mint/90 text-white rounded-full px-6 py-2 transition-all duration-300 hover:shadow-glow-mint w-full relative overflow-hidden" onClick={e => {
            setIsMenuOpen(false);
            handleConnectClick(e);
          }} data-id="element-687">
                <span className="relative z-10" data-id="element-688">{t('nav.connect')}</span>
                <div className="absolute inset-0 opacity-0 hover:opacity-100 transition-opacity duration-300 pointer-events-none" style={{
              background: `radial-gradient(circle at 50% 50%, rgba(255, 255, 255, 0.7) 0%, rgba(255, 255, 255, 0) 60%)`
            }} data-id="element-689" />
              </button>
            </div>
          </div>}
      </nav>
      {/* Connect Modal */}
      <ConnectModal isOpen={isConnectModalOpen} onClose={() => setIsConnectModalOpen(false)} data-id="element-690" />
    </>;
};
export default Navbar;